/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UserIndexRouteImport } from './routes/user/index'
import { Route as SupportIndexRouteImport } from './routes/support/index'
import { Route as PropertyIntakeIndexRouteImport } from './routes/property-intake/index'
import { Route as FirmSettingsIndexRouteImport } from './routes/firm-settings/index'
import { Route as AssessmentsIndexRouteImport } from './routes/assessments/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AssessmentsAssessmentIdRouteImport } from './routes/assessments/$assessmentId'
import { Route as landingTermsRouteImport } from './routes/(landing)/terms'
import { Route as landingPrivacyRouteImport } from './routes/(landing)/privacy'
import { Route as landingFaqRouteImport } from './routes/(landing)/faq'
import { Route as AssessmentsAssessmentIdIndexRouteImport } from './routes/assessments/$assessmentId/index'
import { Route as AssessmentsStaticComparisonsRouteImport } from './routes/assessments/static/comparisons'
import { Route as AssessmentsAssessmentIdComparisonIdRouteImport } from './routes/assessments/$assessmentId/$comparisonId'

const SupportLazyRouteImport = createFileRoute('/support')()
const FirmSettingsLazyRouteImport = createFileRoute('/firm-settings')()
const AssessmentsLazyRouteImport = createFileRoute('/assessments')()
const AdminLazyRouteImport = createFileRoute('/admin')()
const landingLazyRouteImport = createFileRoute('/(landing)')()

const SupportLazyRoute = SupportLazyRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/support.lazy').then((d) => d.Route))
const FirmSettingsLazyRoute = FirmSettingsLazyRouteImport.update({
  id: '/firm-settings',
  path: '/firm-settings',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/firm-settings.lazy').then((d) => d.Route))
const AssessmentsLazyRoute = AssessmentsLazyRouteImport.update({
  id: '/assessments',
  path: '/assessments',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/assessments.lazy').then((d) => d.Route))
const AdminLazyRoute = AdminLazyRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/admin.lazy').then((d) => d.Route))
const landingLazyRoute = landingLazyRouteImport
  .update({
    id: '/(landing)',
    getParentRoute: () => rootRouteImport,
  } as any)
  .lazy(() => import('./routes/(landing).lazy').then((d) => d.Route))
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UserIndexRoute = UserIndexRouteImport.update({
  id: '/user/',
  path: '/user/',
  getParentRoute: () => rootRouteImport,
} as any)
const SupportIndexRoute = SupportIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SupportLazyRoute,
} as any)
const PropertyIntakeIndexRoute = PropertyIntakeIndexRouteImport.update({
  id: '/property-intake/',
  path: '/property-intake/',
  getParentRoute: () => rootRouteImport,
} as any)
const FirmSettingsIndexRoute = FirmSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => FirmSettingsLazyRoute,
} as any)
const AssessmentsIndexRoute = AssessmentsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AssessmentsLazyRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminLazyRoute,
} as any)
const AssessmentsAssessmentIdRoute = AssessmentsAssessmentIdRouteImport.update({
  id: '/$assessmentId',
  path: '/$assessmentId',
  getParentRoute: () => AssessmentsLazyRoute,
} as any)
const landingTermsRoute = landingTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => landingLazyRoute,
} as any)
const landingPrivacyRoute = landingPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => landingLazyRoute,
} as any)
const landingFaqRoute = landingFaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => landingLazyRoute,
} as any)
const AssessmentsAssessmentIdIndexRoute =
  AssessmentsAssessmentIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AssessmentsAssessmentIdRoute,
  } as any)
const AssessmentsStaticComparisonsRoute =
  AssessmentsStaticComparisonsRouteImport.update({
    id: '/static/comparisons',
    path: '/static/comparisons',
    getParentRoute: () => AssessmentsLazyRoute,
  } as any)
const AssessmentsAssessmentIdComparisonIdRoute =
  AssessmentsAssessmentIdComparisonIdRouteImport.update({
    id: '/$comparisonId',
    path: '/$comparisonId',
    getParentRoute: () => AssessmentsAssessmentIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof landingLazyRouteWithChildren
  '/login': typeof LoginRoute
  '/admin': typeof AdminLazyRouteWithChildren
  '/assessments': typeof AssessmentsLazyRouteWithChildren
  '/firm-settings': typeof FirmSettingsLazyRouteWithChildren
  '/support': typeof SupportLazyRouteWithChildren
  '/faq': typeof landingFaqRoute
  '/privacy': typeof landingPrivacyRoute
  '/terms': typeof landingTermsRoute
  '/assessments/$assessmentId': typeof AssessmentsAssessmentIdRouteWithChildren
  '/admin/': typeof AdminIndexRoute
  '/assessments/': typeof AssessmentsIndexRoute
  '/firm-settings/': typeof FirmSettingsIndexRoute
  '/property-intake': typeof PropertyIntakeIndexRoute
  '/support/': typeof SupportIndexRoute
  '/user': typeof UserIndexRoute
  '/assessments/$assessmentId/$comparisonId': typeof AssessmentsAssessmentIdComparisonIdRoute
  '/assessments/static/comparisons': typeof AssessmentsStaticComparisonsRoute
  '/assessments/$assessmentId/': typeof AssessmentsAssessmentIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof landingLazyRouteWithChildren
  '/login': typeof LoginRoute
  '/faq': typeof landingFaqRoute
  '/privacy': typeof landingPrivacyRoute
  '/terms': typeof landingTermsRoute
  '/admin': typeof AdminIndexRoute
  '/assessments': typeof AssessmentsIndexRoute
  '/firm-settings': typeof FirmSettingsIndexRoute
  '/property-intake': typeof PropertyIntakeIndexRoute
  '/support': typeof SupportIndexRoute
  '/user': typeof UserIndexRoute
  '/assessments/$assessmentId/$comparisonId': typeof AssessmentsAssessmentIdComparisonIdRoute
  '/assessments/static/comparisons': typeof AssessmentsStaticComparisonsRoute
  '/assessments/$assessmentId': typeof AssessmentsAssessmentIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/(landing)': typeof landingLazyRouteWithChildren
  '/admin': typeof AdminLazyRouteWithChildren
  '/assessments': typeof AssessmentsLazyRouteWithChildren
  '/firm-settings': typeof FirmSettingsLazyRouteWithChildren
  '/support': typeof SupportLazyRouteWithChildren
  '/(landing)/faq': typeof landingFaqRoute
  '/(landing)/privacy': typeof landingPrivacyRoute
  '/(landing)/terms': typeof landingTermsRoute
  '/assessments/$assessmentId': typeof AssessmentsAssessmentIdRouteWithChildren
  '/admin/': typeof AdminIndexRoute
  '/assessments/': typeof AssessmentsIndexRoute
  '/firm-settings/': typeof FirmSettingsIndexRoute
  '/property-intake/': typeof PropertyIntakeIndexRoute
  '/support/': typeof SupportIndexRoute
  '/user/': typeof UserIndexRoute
  '/assessments/$assessmentId/$comparisonId': typeof AssessmentsAssessmentIdComparisonIdRoute
  '/assessments/static/comparisons': typeof AssessmentsStaticComparisonsRoute
  '/assessments/$assessmentId/': typeof AssessmentsAssessmentIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/admin'
    | '/assessments'
    | '/firm-settings'
    | '/support'
    | '/faq'
    | '/privacy'
    | '/terms'
    | '/assessments/$assessmentId'
    | '/admin/'
    | '/assessments/'
    | '/firm-settings/'
    | '/property-intake'
    | '/support/'
    | '/user'
    | '/assessments/$assessmentId/$comparisonId'
    | '/assessments/static/comparisons'
    | '/assessments/$assessmentId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/faq'
    | '/privacy'
    | '/terms'
    | '/admin'
    | '/assessments'
    | '/firm-settings'
    | '/property-intake'
    | '/support'
    | '/user'
    | '/assessments/$assessmentId/$comparisonId'
    | '/assessments/static/comparisons'
    | '/assessments/$assessmentId'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/(landing)'
    | '/admin'
    | '/assessments'
    | '/firm-settings'
    | '/support'
    | '/(landing)/faq'
    | '/(landing)/privacy'
    | '/(landing)/terms'
    | '/assessments/$assessmentId'
    | '/admin/'
    | '/assessments/'
    | '/firm-settings/'
    | '/property-intake/'
    | '/support/'
    | '/user/'
    | '/assessments/$assessmentId/$comparisonId'
    | '/assessments/static/comparisons'
    | '/assessments/$assessmentId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  landingLazyRoute: typeof landingLazyRouteWithChildren
  AdminLazyRoute: typeof AdminLazyRouteWithChildren
  AssessmentsLazyRoute: typeof AssessmentsLazyRouteWithChildren
  FirmSettingsLazyRoute: typeof FirmSettingsLazyRouteWithChildren
  SupportLazyRoute: typeof SupportLazyRouteWithChildren
  PropertyIntakeIndexRoute: typeof PropertyIntakeIndexRoute
  UserIndexRoute: typeof UserIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/support': {
      id: '/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof SupportLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/firm-settings': {
      id: '/firm-settings'
      path: '/firm-settings'
      fullPath: '/firm-settings'
      preLoaderRoute: typeof FirmSettingsLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assessments': {
      id: '/assessments'
      path: '/assessments'
      fullPath: '/assessments'
      preLoaderRoute: typeof AssessmentsLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(landing)': {
      id: '/(landing)'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof landingLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/user/': {
      id: '/user/'
      path: '/user'
      fullPath: '/user'
      preLoaderRoute: typeof UserIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/support/': {
      id: '/support/'
      path: '/'
      fullPath: '/support/'
      preLoaderRoute: typeof SupportIndexRouteImport
      parentRoute: typeof SupportLazyRoute
    }
    '/property-intake/': {
      id: '/property-intake/'
      path: '/property-intake'
      fullPath: '/property-intake'
      preLoaderRoute: typeof PropertyIntakeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/firm-settings/': {
      id: '/firm-settings/'
      path: '/'
      fullPath: '/firm-settings/'
      preLoaderRoute: typeof FirmSettingsIndexRouteImport
      parentRoute: typeof FirmSettingsLazyRoute
    }
    '/assessments/': {
      id: '/assessments/'
      path: '/'
      fullPath: '/assessments/'
      preLoaderRoute: typeof AssessmentsIndexRouteImport
      parentRoute: typeof AssessmentsLazyRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminLazyRoute
    }
    '/assessments/$assessmentId': {
      id: '/assessments/$assessmentId'
      path: '/$assessmentId'
      fullPath: '/assessments/$assessmentId'
      preLoaderRoute: typeof AssessmentsAssessmentIdRouteImport
      parentRoute: typeof AssessmentsLazyRoute
    }
    '/(landing)/terms': {
      id: '/(landing)/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof landingTermsRouteImport
      parentRoute: typeof landingLazyRoute
    }
    '/(landing)/privacy': {
      id: '/(landing)/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof landingPrivacyRouteImport
      parentRoute: typeof landingLazyRoute
    }
    '/(landing)/faq': {
      id: '/(landing)/faq'
      path: '/faq'
      fullPath: '/faq'
      preLoaderRoute: typeof landingFaqRouteImport
      parentRoute: typeof landingLazyRoute
    }
    '/assessments/$assessmentId/': {
      id: '/assessments/$assessmentId/'
      path: '/'
      fullPath: '/assessments/$assessmentId/'
      preLoaderRoute: typeof AssessmentsAssessmentIdIndexRouteImport
      parentRoute: typeof AssessmentsAssessmentIdRoute
    }
    '/assessments/static/comparisons': {
      id: '/assessments/static/comparisons'
      path: '/static/comparisons'
      fullPath: '/assessments/static/comparisons'
      preLoaderRoute: typeof AssessmentsStaticComparisonsRouteImport
      parentRoute: typeof AssessmentsLazyRoute
    }
    '/assessments/$assessmentId/$comparisonId': {
      id: '/assessments/$assessmentId/$comparisonId'
      path: '/$comparisonId'
      fullPath: '/assessments/$assessmentId/$comparisonId'
      preLoaderRoute: typeof AssessmentsAssessmentIdComparisonIdRouteImport
      parentRoute: typeof AssessmentsAssessmentIdRoute
    }
  }
}

interface landingLazyRouteChildren {
  landingFaqRoute: typeof landingFaqRoute
  landingPrivacyRoute: typeof landingPrivacyRoute
  landingTermsRoute: typeof landingTermsRoute
}

const landingLazyRouteChildren: landingLazyRouteChildren = {
  landingFaqRoute: landingFaqRoute,
  landingPrivacyRoute: landingPrivacyRoute,
  landingTermsRoute: landingTermsRoute,
}

const landingLazyRouteWithChildren = landingLazyRoute._addFileChildren(
  landingLazyRouteChildren,
)

interface AdminLazyRouteChildren {
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminLazyRouteChildren: AdminLazyRouteChildren = {
  AdminIndexRoute: AdminIndexRoute,
}

const AdminLazyRouteWithChildren = AdminLazyRoute._addFileChildren(
  AdminLazyRouteChildren,
)

interface AssessmentsAssessmentIdRouteChildren {
  AssessmentsAssessmentIdComparisonIdRoute: typeof AssessmentsAssessmentIdComparisonIdRoute
  AssessmentsAssessmentIdIndexRoute: typeof AssessmentsAssessmentIdIndexRoute
}

const AssessmentsAssessmentIdRouteChildren: AssessmentsAssessmentIdRouteChildren =
  {
    AssessmentsAssessmentIdComparisonIdRoute:
      AssessmentsAssessmentIdComparisonIdRoute,
    AssessmentsAssessmentIdIndexRoute: AssessmentsAssessmentIdIndexRoute,
  }

const AssessmentsAssessmentIdRouteWithChildren =
  AssessmentsAssessmentIdRoute._addFileChildren(
    AssessmentsAssessmentIdRouteChildren,
  )

interface AssessmentsLazyRouteChildren {
  AssessmentsAssessmentIdRoute: typeof AssessmentsAssessmentIdRouteWithChildren
  AssessmentsIndexRoute: typeof AssessmentsIndexRoute
  AssessmentsStaticComparisonsRoute: typeof AssessmentsStaticComparisonsRoute
}

const AssessmentsLazyRouteChildren: AssessmentsLazyRouteChildren = {
  AssessmentsAssessmentIdRoute: AssessmentsAssessmentIdRouteWithChildren,
  AssessmentsIndexRoute: AssessmentsIndexRoute,
  AssessmentsStaticComparisonsRoute: AssessmentsStaticComparisonsRoute,
}

const AssessmentsLazyRouteWithChildren = AssessmentsLazyRoute._addFileChildren(
  AssessmentsLazyRouteChildren,
)

interface FirmSettingsLazyRouteChildren {
  FirmSettingsIndexRoute: typeof FirmSettingsIndexRoute
}

const FirmSettingsLazyRouteChildren: FirmSettingsLazyRouteChildren = {
  FirmSettingsIndexRoute: FirmSettingsIndexRoute,
}

const FirmSettingsLazyRouteWithChildren =
  FirmSettingsLazyRoute._addFileChildren(FirmSettingsLazyRouteChildren)

interface SupportLazyRouteChildren {
  SupportIndexRoute: typeof SupportIndexRoute
}

const SupportLazyRouteChildren: SupportLazyRouteChildren = {
  SupportIndexRoute: SupportIndexRoute,
}

const SupportLazyRouteWithChildren = SupportLazyRoute._addFileChildren(
  SupportLazyRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  landingLazyRoute: landingLazyRouteWithChildren,
  AdminLazyRoute: AdminLazyRouteWithChildren,
  AssessmentsLazyRoute: AssessmentsLazyRouteWithChildren,
  FirmSettingsLazyRoute: FirmSettingsLazyRouteWithChildren,
  SupportLazyRoute: SupportLazyRouteWithChildren,
  PropertyIntakeIndexRoute: PropertyIntakeIndexRoute,
  UserIndexRoute: UserIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
